import { Box, Skeleton } from "@mui/material";


const ChartsSkeleton = ({ count = 1 }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    {/* Skeleton for the Title */}
    <Skeleton variant="text" width="80%" height={30} />

    {/* Skeleton for Pie Chart */}
    <Skeleton variant="rectangular" width="100%" height={300} />

    {/* Skeleton for Text or Additional Information */}
    <Skeleton variant="text" width="60%" height={20} />
  </Box>
  );
};

export default ChartsSkeleton;
